import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { OrderDraftState } from '../reducers/orderDraftCreation';

export const isOrderDraftCreationLoadingSelector = createSelector((state: DefaultRootState) => state.orderDraftCreation,
  ({loading}: OrderDraftState) => loading
);
